var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAiLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 67.2 66.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#b2fb00",
    d: "M43.7 15.9h8.6v49.5h-8.6v-8.5c-4.3 6.5-10.5 9.8-18.7 9.8-6.9 0-12.8-2.5-17.7-7.6C2.4 54.1 0 47.9 0 40.7s2.4-13.4 7.3-18.4 10.8-7.6 17.7-7.6c8.2 0 14.4 3.3 18.7 9.8v-8.6zM26.1 58.4c5 0 9.2-1.7 12.6-5.1 3.4-3.4 5-7.6 5-12.6s-1.7-9.2-5-12.6c-3.4-3.4-7.6-5.1-12.6-5.1-4.9 0-9.1 1.7-12.5 5.1s-5 7.6-5 12.6 1.7 9.2 5 12.6c3.4 3.4 7.6 5.1 12.5 5.1zm35.4-46.8c-1.7 0-3-.6-4.2-1.7-1.1-1.1-1.7-2.5-1.7-4.1s.6-2.9 1.7-4.1C58.5.6 59.8 0 61.5 0c1.6 0 2.9.6 4 1.7 1.1 1.2 1.7 2.5 1.7 4.1s-.6 2.9-1.7 4.1c-1.1 1.1-2.4 1.7-4 1.7zm-4.4 4.3h8.6v49.5h-8.6V15.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiLogo);
export default __webpack_public_path__ + "static/media/aiLogo.7b27496fd77531a36002ed326946ff1a.svg";
export { ForwardRef as ReactComponent };